export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwo_rg.66afbc45.jpg";